import { useContext, useEffect, useState } from "react";
import {
  getTranslations,
  createTranslation,
  createTranslations,
  updateTranslation,
  deleteTranslation,
  exportTranslations,
  importTranslations,
} from "../services/console/translations";
import { AppContext } from "../context";

type UseType = "DATA" | "ACTIONS";
type ActionType = "CREATE" | "CREATEALL" | "UPDATE" | "DELETE" | "DOWNLOAD" | "IMPORT";

const handleTranslationActionFunction = (action: ActionType, t: Function) => {
  switch (action) {
    case "CREATE":
      return {
        actionFn: createTranslation,
        fnMsg: t("Translations.translationsApiCreateLabel"),
      };
    case "CREATEALL":
        return {
          actionFn: createTranslations,
          fnMsg: t("Translations.translationsApiCreateLabel"),
        };
    case "UPDATE":
      return {
        actionFn: updateTranslation,
        fnMsg: t("Translations.translationsApiUpdateLabel"),
      };
    case "DELETE":
      return {
        actionFn: deleteTranslation,
        fnMsg: t("Translations.translationsApiDeleteLabel"),
      };
    case "DOWNLOAD":
      return {
        actionFn: exportTranslations,
        fnMsg: t("Translations.translationsApiDownloadLabel"),
      };
    case "IMPORT":
      return {
        actionFn: importTranslations,
        fnMsg: t("Translations.translationsApiImportLabel"),
      };
    default:
      return {
        actionFn: () => {},
        fnMsg: "",
      };
  }
};

export const useConsoleTranslation = (type: UseType) => {
  const {
    t,
    toast,
    appState: { selectedApp },
    setAppState,
  } = useContext(AppContext);
  const [data, setData] = useState<any | null>(null);
  const [reload, setReload] = useState<number>(0);
  const appid = selectedApp?.appid || "0";

  const reloadFn = () => {
    setData(null);
    setReload((prev) => prev + 1);
  };

  const translationAction = async (action: ActionType, data: any) => {
    const { actionFn, fnMsg } = handleTranslationActionFunction(action, t);
    setAppState((prev) => ({
      ...prev,
      isLoading: true,
    }));
    const actionStatus = await Promise.resolve(actionFn(data))
      .then((response) => {
        toast.current.replace({
          severity: "success",
          summary: "",
          detail: `${fnMsg}`,
          life: 3000,
        });
        return "SUCCESS";
      })
      .catch((error) => {
        toast.current.replace({
          severity: "error",
          summary: "",
          detail: error?.response?.data?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
          life: 3000,
        });
        return "ERROR";
      });
    setAppState((prev) => ({
      ...prev,
      isLoading: false,
    }));
    return actionStatus;
  };

  useEffect(() => {
    if (type === "DATA") {
      (async function () {
        await Promise.resolve(getTranslations())
          .then((response) => {
            setData(response?.data);
          })
          .catch((error) => {
            toast.current.replace({
              severity: "error",
              summary: "",
              detail: error?.response?.header?.errorMsg ?? t('ConsoleTranslations.generalErrorApiMessage'),
              life: 3000,
            });
          });
      })();
    }
  }, [appid, toast, reload, type]);

  return {
    data,
    translationAction,
    reloadFn,
  };
};
